// controlsContainerTutorialSteps.ts
import { Step } from "react-joyride";

export const controlsContainerTutorialSteps: Step[] = [
    // Step 0
    {
        target: ".joyride-controls-container", // Target the entire page
        content:
            "This controls bar contains different features you can do to your image once its been generated, such as edits, entering competitions, and so on.",
        placement: "bottom",
        isFixed: false,
        disableOverlay: true,
        disableBeacon: true, // Disable the initial dot
    },
    // Step 1
    {
        target: ".joyride-controls-container",
        content: "Here are various actions you can perform on your image.",
        placement: "bottom",
    },
    // Step 2
    {
        target: ".joyride-share-button",
        content: "Click here to share your image with others and earn gold.",
        placement: "bottom",
    },
    // Step 1.3
    {
        target: ".joyride-ellipsis-button",
        content: "Access more editing features here.",
        placement: "bottom",
    },
    // Step 1.3.x (Options within the Popover)
    {
        target: ".joyride-download-option",
        content: "Download your image in full size.",
        placement: "right",
    },
    {
        target: ".joyride-competition-option",
        content: "Enter your image into competitions and earn gold if you win.",
        placement: "right",
    },
    {
        target: ".joyride-delete-option",
        content: "Delete the image if you're unhappy with it.",
        placement: "right",
    },
    {
        target: ".joyride-refine-faces-option",
        content:
            "Refine faces in your image for better quality, this will keep the rest of the image the same.",
        placement: "right",
    },
    {
        target: ".joyride-swap-faces-option",
        content:
            "Swap faces in the image with one of your own, try it out after the tutorial, it's great fun!",
        placement: "right",
    },
    {
        target: ".joyride-remove-bg-option",
        content:
            "Remove the background from your image, this can be useful if you want to use the character as a token for VTTs.",
        placement: "right",
    },
    {
        target: ".joyride-spot-edit-option",
        content:
            "Edit a specific part of the image while keeping the rest the same, this is also known as inpainting.",
        placement: "right",
    },
    {
        target: ".joyride-upscale-option",
        content: "Upscale your image to higher resolutions upto 4K!",
        placement: "right",
    },
    // Step 1.4
    {
        target: ".joyride-public-toggle",
        content:
            "Toggle this to make your image public and appear in the public gallery for other users to vote and comment.",
        placement: "bottom",
    },
    // Step 1.5
    {
        target: ".joyride-heart-icon",
        content:
            "Vote for your image if you liked it, others can also vote for public images!",
        placement: "bottom",
    },
];
